<div class="ds-modal ds-modal--auto clave">
  <div class="ds-accent"></div>

  <div class="ds-modal__head">
    <span class="ds-modal__head-icon material-icons">lock</span>
    <div>
      <h2>{{ idioma | translate: "form.MODIFICAR-CLAVE" | async }}</h2>
      <p>Elegí una contraseña segura de 6 a 10 caracteres.</p>
    </div>
    <span class="ds-modal__spacer"></span>
    <button type="button" class="ds-icon-btn" (click)="closeModal()" aria-label="Cerrar">
      <span class="material-icons">close</span>
    </button>
  </div>

  <div class="ds-modal__body">
    <form [formGroup]="form" (ngSubmit)="put()">
      <div class="ds-card">
        <div class="ds-section__head">
          <span class="material-icons">key</span>
          Nueva contraseña
        </div>
        <div class="ds-section__body">
          <div class="ds-field">
            <label class="ds-field__label" for="clave-nueva">{{ idioma | translate: "login.CONTRASENA" | async }}</label>
            <div class="ds-field__control clave__control">
              <input
                id="clave-nueva"
                class="ds-field__input clave__input"
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                [class.is-invalid]="passwordNoValido"
                [placeholder]="idioma | translate: 'login.placeholders.INGRESE-CONTRASENA' | async"
                autocomplete="off">
              <button type="button" class="clave__toggle"
                (click)="showPassword = !showPassword"
                [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                <i class="far" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            <small class="clave__error" *ngIf="passwordNoValido">La contraseña debe tener entre 6 y 10 caracteres.</small>
          </div>

          <div class="ds-field">
            <label class="ds-field__label" for="clave-confirmar">{{ idioma | translate: "login.CONFIRMAR-CONTRASENA" | async }}</label>
            <div class="ds-field__control clave__control">
              <input
                id="clave-confirmar"
                class="ds-field__input clave__input"
                [type]="showPasswordConfirm ? 'text' : 'password'"
                formControlName="confirmPassword"
                [class.is-invalid]="confirmPasswordNoValido"
                [placeholder]="idioma | translate: 'login.CONFIRMAR-CONTRASENA' | async"
                autocomplete="off">
              <button type="button" class="clave__toggle"
                (click)="showPasswordConfirm = !showPasswordConfirm"
                [attr.aria-label]="showPasswordConfirm ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                <i class="far" [ngClass]="showPasswordConfirm ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
            <small class="clave__error" *ngIf="confirmPasswordNoValido">{{ idioma | translate: "login.CONTRASENA-INVALIDA" | async }}</small>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="ds-modal__actions">
    <button type="button" class="ds-pill ds-pill--ghost" (click)="closeModal()">
      {{ idioma | translate: "form.BTN-CANCELAR" | async }}
    </button>
    <button type="button" class="ds-pill ds-pill--primary" [disabled]="form.invalid || isUpdatingPwd" (click)="put()">
      <span class="material-icons">save</span>
      {{ idioma | translate: "form.BTN-ACEPTAR" | async }}
    </button>
  </div>
</div>

<!-- Spinner global para feedback visual -->
<app-spinner
    [show]="isUpdatingPwd"
    [text]="'Modificando clave, por favor espere'"
    [type]="'fullscreen'"
    [color]="'#B1476A'" [trackColor]="'#4CA7C8'"
    [blurBackground]="true">
</app-spinner>
